export default "__VITE_ASSET__mHnEZFvP__"